<template>
    <div class="card__header display--flex">
        <div class="card__header__title capitalize">{{ title }}</div>
        <div class="card__header__actions">
            <template v-if="actions.create.modal">
                <div
                    class="card__header__actions__modal position--relative"
                    v-on="{
                        ...( actions.create.block && {
                            mouseover: () => showTooltip = true,
                            mouseleave: () => showTooltip = false
                        })
                    }"
                >
                    <modal-button
                        :targetClass="`card__header__actions__modal__button${ actions.create.block ? ' disable' : ''}`"
                        :label="$t('global.create')"
                    />
                    <template v-if="actions.create.block">
                    <tooltip
                        v-show="showTooltip"
                        class="card__header__actions__tooltip"
                        direction="top"
                        arrow="center"
                        v-html="$t('global.exitEditMode')"
                    />
                    </template>
                </div>
            </template>
            <router-link
                v-else
                :to="`/${actions.create.model}/add`"
                class="
                    card__header__actions__info
                    position--relative
                    display--inline-b
                    capitalize accessibility--pseudo
                    accessibility--pseudo--default
                    accessibility--active
                "
            >
                <span class="card__header__actions__info__anchor">{{ $t('global.create') }}</span>
            </router-link>
            <router-link
                v-if="actions.see.show"
                :to="actions.see.link"
                class="
                    card__header__actions__info
                    position--relative display--inline-b
                    capitalize accessibility--pseudo
                    accessibility--pseudo--default accessibility--active
                "
            >
                <span class="card__header__actions__info__anchor">{{ $t('global.viewMore') }}</span>
            </router-link>
        </div>
    </div>
</template>

<script>
// package
import { ref } from '@vue/composition-api';

export default {
    components: {
        ModalButton: () => import( /* webpackChunkName: 'FunctionalModal' */ '@/components/bundles/functional/Modal' ).then( c => c.modalButton ),
        Tooltip: () => import( /* webpackChunkName: 'Tooltips' */ '@/components/bundles/tooltips/Tooltip' )
    },
    props: {
        title: String,
        actions: Object
    },
    setup () {
        const showTooltip = ref( false );

        return { showTooltip };
    }
};
</script>

<style lang="scss">
    .card {
        &__header {
            align-items: center;
            justify-content: space-between;
            &__actions {
                @include typography-specs( 18px, 24px, 400 );
                &__info {
                    &:not(:last-child) {
                        margin-right: 20px;
                    }
                }
                &__tooltip {
                    width: max-content;
                    @include transform-position( -25px, false, false, 50%, translateX( -50% ) );
                }
            }
        }
    }
</style>